export const PlusIcon = ({ color = 'white' }: { color?: string }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="plus">
      <path
        id="Vector"
        d="M3.60001 11.9996H20.4M12 3.59961V20.3996"
        stroke={color}
        strokeOpacity="1"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
